import React, {Fragment, useEffect, useState} from 'react';
import {useDropzone} from 'react-dropzone';
import {IconPhoto, IconX} from '@tabler/icons-react';
import Gallery from '../../components/Gallery/Gallery.js';
import {
    Col,
    Card,
    CardImg,
    CardImgOverlay,
    Spinner,
    Button,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Alert, Label,
    CardBody
} from 'reactstrap';
import classes from './NewMediaUpload.module.scss';
import axios from "../../axios-base";
import FormInput from "../../components/UI/Input/FormInput";


function NewMediaUpload(props) {
    const [fileToDelete, setFileToDelete] = useState({});
    const [processedFiles, setProcessedFiles] = useState([]);
    const [unprocessedFiles, setUnprocessedFiles] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [isLoadingFiles, setIsLoadingFiles] = useState(false);
    const [serverUrls, setServerUrls] = useState([]);
    const [showNotice, setShowNotice] = useState(false);
    const [rejectedFiles, setRejectedFiles] = useState([]);
    const [altTexts, setAltTexts] = useState({});
    const {getRootProps, getInputProps} = useDropzone({
        accept: {
            'image/png': ['.png'],
            'image/jpg': ['.jpg'],
            'image/jpeg': ['.jpeg']
        },
        maxSize: 10000000,
        maxFiles: 9,
        onDropAccepted: acceptedFiles => {
            if (acceptedFiles.length + processedFiles.length <= 9) {
                uploadFiles(acceptedFiles);
                // acceptedFiles.map(file => Object.assign(file, {
                //     preview: URL.createObjectURL(file)
                // }));
                displayUnprocessedFiles(acceptedFiles);
            } else {
                setShowNotice(true);
            }
        },
        onDropRejected: files => {
            setRejectedFiles(files);
            setShowNotice(true);
        }
    });

    const displayUnprocessedFiles = files => {
        files.map(file => Object.assign(file, {
            preview: URL.createObjectURL(file)
        }));
        setUnprocessedFiles([...files]);
    }

    const uploadFiles = (filesToUpload) => {
        setIsLoadingFiles(true);
        //send the post request for files provided
        const arrayOfPostedFormData = filesToUpload.map((file) => {
            // create form
            const fd = new FormData();
            const axiosConfig = {
                onUploadProgress: (progressEvent) => {
                    return (progressEvent.loaded * 100) / progressEvent.total;
                }
            };
            fd.append('projectGallery', file);

            // Initialize alt text for the file
            setAltTexts(prevAltTexts => ({
                ...prevAltTexts,
                [file.name]: ''
            }));

            return axios.post('/media', fd, axiosConfig);
        });

        Promise.all(arrayOfPostedFormData).then((response) => {
            if (typeof response[0] !== 'undefined') {
                setProcessedFiles(prevState => [...prevState, ...filesToUpload]);
                let newArrayResponse = [];
                response.forEach(item => {
                    newArrayResponse.push(item.data.projectGallery[0]);
                });
                setServerUrls(prevState => [...prevState, ...newArrayResponse]);
                setIsLoadingFiles(false);
            }
        }).catch(error => {
            modalHandler();
        })
    }

    const removePromptHandler = file => {
        modalHandler();
        setFileToDelete(file);
    };

    const modalHandler = () => {
        // console.log("modalHandler Called!");
        setShowModal(!showModal);
    }

    const removeFileHandler = () => {
        // console.log("removeFileHandler Called!");
        if (fileToDelete) {
            URL.revokeObjectURL(fileToDelete.preview);
            const indexOfProcessedFile = processedFiles.indexOf(fileToDelete);
            const indexOfUnProcessedFile = unprocessedFiles.indexOf(fileToDelete);
            //update the form urls
            setServerUrls(prevState => {
                console.log("Prev State of form urls: ", prevState);
                console.log("FILE URL found to be removed: ", prevState.filter(url => url === fileToDelete.url))
                return (prevState.filter(response => response.originalname !== fileToDelete.path));
            });
            if (indexOfProcessedFile >= 0) {
                const newFiles = [...processedFiles];
                newFiles.splice(indexOfProcessedFile, 1);
                setProcessedFiles(newFiles);

                // Also remove alt text for this file
                setAltTexts(prevAltTexts => {
                    const newAltTexts = {...prevAltTexts};
                    delete newAltTexts[fileToDelete.name];
                    return newAltTexts;
                });
            }
            if (indexOfUnProcessedFile > 0) {
                const newFiles = [...unprocessedFiles];
                newFiles.splice(indexOfUnProcessedFile, 1);
                setUnprocessedFiles(newFiles);
            }
        }
        setIsLoadingFiles(false);
        modalHandler();

    }

    const dismissAlert = () => {
        setShowNotice(false);
    }

    const handleAltTextChange = (fileName, value) => {
        setAltTexts(prevAltTexts => ({
            ...prevAltTexts,
            [fileName]: value
        }));
    }

    useEffect(() => {
        // Make sure to revoke the data uris to avoid memory leaks
        return () => {
            [...processedFiles, ...unprocessedFiles].map((file) => URL.revokeObjectURL(file.preview));

            // console.log("File URLs have been revoked");
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        setUnprocessedFiles([]);

        // Create new array with URLs and alt text in the required format
        const formattedUrls = serverUrls.map(item => {
            // Find the corresponding processed file to get its name for the alt text lookup
            const matchingFile = processedFiles.find(file => file.path === item.originalname);
            const altText = matchingFile ? altTexts[matchingFile.name] || '' : '';

            return {
                url: item.transforms[0].location,
                alt: altText
            };
        });

        props.onUploadHandler(formattedUrls);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [processedFiles, serverUrls, altTexts]);

    const processedThumbs = processedFiles.map((file, index) => {
        return (
            <Col xs="12" s="6" md="6" lg="4" className="my-2" key={file.name}>
                <Card className={classes.MediaFile}>
                    <CardImg
                        className={classes.CardImg}
                        // className={classes.CardImg}
                        top
                        width="100%"
                        src={file.preview}
                        alt={altTexts[file.name] || `Bild ${index + 1} vollständig hochgeladen!`}/>
                    <CardImgOverlay style={{height: "min-content", width: "min-content", justifySelf: "end"}}>
                        <div className={classes.deleteArea}>
                            <Button onClick={() => removePromptHandler(file)} disabled={isLoadingFiles}
                                    color="danger" className={classes.buttonDelete}
                                    title={`Bild ${index + 1} entfernen`}><IconX className={classes.icon}
                                                                                           size={32}/></Button>
                        </div>
                    </CardImgOverlay>
                    <CardBody className={classes.altTextContainer}>
                        <FormInput
                            elementConfig={{
                                label: `Beschreibung für Bild ${index + 1}`,
                                type: "textarea",
                                placeholder: "Beispiel: Die Jugendfeuerwehr bei einer Löschübung am See."
                            }}
                            wrapperCSSClass="mb-0"
                            maxLenght={150}
                            value={altTexts[file.name] || ''}
                            changed={(e) => handleAltTextChange(file.name, e.target.value)}
                            id={`alt-text-${index}`}
                        />
                    </CardBody>
                </Card>
            </Col>
        );
    });

    const unProcessedThumbs = unprocessedFiles.map((file, index) => (
        <Col xs="12" s="6" md="6" lg="4" className="my-2" key={index}>
            <Card className={isLoadingFiles ? classes.MediaFile + " " + classes.Loading : classes.MediaFile}>
                <div key={file.name}>
                    <CardImg
                        className={classes.CardImg}
                        // className={classes.CardImg}
                        top
                        width="100%"
                        src={file.preview}
                        alt={altTexts[file.name] || `Bild ${index + processedFiles.length} wird noch verarbeitet`}/>
                    <CardImgOverlay className={classes.cardImageOverlay}>
                        <div className={classes.spinnerParentShow}>
                            <Spinner style={{width: '3rem', height: '3rem'}}/>{' '}
                        </div>
                        <div className={classes.deleteArea}>
                            <Button onClick={() => removePromptHandler(file)} disabled={isLoadingFiles} color="danger"
                                    className={classes.buttonDelete}
                                    title={`Bild ${index + 1} entfernen`}><IconX className={classes.icon}
                                                                                           size={32}/></Button>
                        </div>
                    </CardImgOverlay>

                </div>
                <div className={classes.altTextContainer}>
                    <FormInput
                        elementConfig={{
                            label: `Alternativtext für Bild ${index + 1}`,
                            type: "text",
                            placeholder: "Alternativtext eingeben"
                        }}
                        wrapperCSSClass="mb-0"
                        maxLenght={150}
                        value={altTexts[file.name] || ''}
                        changed={(e) => handleAltTextChange(file.name, e.target.value)}
                        id={`alt-text-${index}`}
                    />
                </div>
            </Card>
        </Col>
    ));

    const strings = {
        removeModalHeader: "Entfernen",
        removeModalMessage: "Wollen Sie die Datei löschen?",
        removeModalAbortButton: "Abbrechen",
        removeModalRemoveButton: "Löschen",
        uploadFailedMessage: "Einige Bilder konnten nicht hochgeladen werden. Bitte überprüfen Sie Dateityp, -größe und -anzahl (max. 9 Bilder). <strong>Sie können Ihre Bewerbung trotzdem absenden</strong>, aber die folgenden Bilder werden ausgelassen:",
        uploadInputLabel: "Bilder hinzufügen (max. Größe 10MB je Bild)",
        uploadingStatusLabel: "Bitte warten Sie bis die Bilder hochgeladen wurden"
    }

    const inputId = props.id ?? "mediaUpload";

    return (
        <Fragment>
            <Modal centered isOpen={showModal}>
                <ModalHeader toggle={modalHandler}>{strings.removeModalHeader}</ModalHeader>
                <ModalBody>
                    {strings.removeModalMessage}
                    <div>{fileToDelete.path}</div>
                </ModalBody>
                <ModalFooter>
                    <Button outline color="secondary"
                            onClick={modalHandler}>{strings.removeModalAbortButton}</Button>{' '}
                    <Button color="secondary" onClick={removeFileHandler}>{strings.removeModalRemoveButton}</Button>
                </ModalFooter>
            </Modal>
            <section>
                <aside>
                    <Gallery isSignup>{processedThumbs}{unProcessedThumbs}</Gallery>
                </aside>
                <Alert isOpen={showNotice} toggle={dismissAlert} color="warning">
                    <div dangerouslySetInnerHTML={{__html: strings.uploadFailedMessage}}/>
                    <ul>
                        {rejectedFiles.map((file, index) => {
                            return (<li key={index}>{file.file.name}</li>);
                        })}
                    </ul>
                </Alert>
                <div {...getRootProps()}>
                    {!isLoadingFiles
                        && <input {...getInputProps()} id={inputId}
                                  name={strings.uploadInputLabel} aria-label={strings.uploadInputLabel}
                                  aria-labelledby={inputId + "Label"}
                                  className="visually-hidden"
                                  style={null}/>}
                    {/*<input {...getInputProps()} />*/}
                        <Label id={inputId + "Label"} aria-live="polite"
                           className={classes.Dropzone + ' ' + (isLoadingFiles ? classes.dropzoneDisabled : classes.dropzoneEnabled)}>
                        <IconPhoto className="px-1" size={32}/>
                        {isLoadingFiles ? strings.uploadingStatusLabel : strings.uploadInputLabel}
                    </Label>
                </div>

            </section>
        </Fragment>
    );
}

export default NewMediaUpload;